/* import __COLOCATED_TEMPLATE__ from './report-card-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();